"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteBauform = void 0;
var KetteBauform;
(function (KetteBauform) {
    KetteBauform["kette"] = "Kette";
    KetteBauform["rohr"] = "Rohr";
})(KetteBauform = exports.KetteBauform || (exports.KetteBauform = {}));
//# sourceMappingURL=KetteBauform.js.map